<template>
  <!-- Travaux et inspection (état des lieux): one table of constats for
       the unit, Ajouter opens the constat form -->
  <div class="box-container">
    <d-header
      fluid
      :actions="[
        {
          label: $t('add_constat'),
          resource: 'propertyInspection',
          primary: true,
          color: 'is-primary',
          action: openCreate,
        },
      ]"
      :breadcrumbs="false"
    >
      <h3 class="title is-4">
        {{ $t("property_inspections").capitalize() }}
      </h3>
    </d-header>

    <v-works-table
      ref="works"
      :property-id="model.id"
    />
  </div>
</template>

<script>
import WorksTable from "./components/WorksTable.vue";

export default {
  metaInfo() {
    return {
      title: this.$t("property_inspections").capitalize()
    };
  },
  components: {
    "v-works-table": WorksTable,
  },
  props: {
    model: {
      default: null,
      type: Object,
    },
  },
  methods: {
    openCreate() {
      this.$refs.works.openCreate(this.model.id);
    },
  },
};
</script>
